import React from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import Stats from "../components/homeComponents/Stats";
import Products from "./Products";
import Contact from "./Contact";

const Home = () => {
  return (
    <Container>
      <Banner />
      <Products />
      <Stats />
      {/* <Contact /> */}
    </Container>
  );
};
const Container = styled.div`
  padding: 0;
`;

export default Home;
